angular.module('omfm').controller('wkSystemReportCtrl', WkSystemReportController);

WkSystemReportController.$inject = ['$scope', 'WkSystem', '$location', '$rootScope', '$timeout'];

function WkSystemReportController($scope, WkSystem, $location, $rootScope, $timeout) {
	let loading = false;
	let scrollPosition = 0;

	function getReport() {
		let tables = [];
		['selectCols', 'sumCols', 'countCols', 'groupCols', 'filterGroups'].forEach(function(collection){
			$scope[collection].forEach(function(col){
				if (tables.indexOf(col.table) === -1){
					tables.push(col.table);
				}
			});
		});

		WkSystem[$scope.mode]({
			page:         $scope.currentPage,
			select:       $scope.selectCols,
			sumCols:      $scope.sumCols,
			countCols:    $scope.countCols,
			groupCols:    $scope.groupCols,
			filterGroups: $scope.filterGroups,
			tables:       tables,
			orderBy:      $scope.order[$scope.mode],
		}, function (response) {
			loading = false;
			if($scope.mode === 'list'){
				$scope.totalItems   = response.total;
				$scope.itemsPerPage = response.per_page;
				$scope.currentPage  = response.current_page;
				$scope.results.list = response.data;
			} else {
				$scope.results.group = response;
			}

			$timeout(function(){
				window.scrollTo(0, scrollPosition);
			}, 50);

		});
	}

	$scope.pageChanged = function (page) {
		$scope.currentPage = page || $scope.currentPage;

		scrollPosition = window.scrollY;

		$location.search('filterGroups', JSON.stringify($scope.filterGroups));
		$location.search('selectCols',   JSON.stringify($scope.selectCols));
		$location.search('groupCols',    JSON.stringify($scope.groupCols));
		$location.search('sumCols',      JSON.stringify($scope.sumCols));
		$location.search('countCols',    JSON.stringify($scope.countCols));
		$location.search('order',        JSON.stringify($scope.order));
		$location.search('page',         $scope.currentPage);

		getReport();
	};

	$scope.cantGroup = function(){
		return $scope.groupCols.length === 0 || ($scope.countCols.length === 0 && $scope.sumCols.length === 0);
	};

	$scope.setOrder = function (order, mode) {
		if ($scope.order[mode].field === order) {
			$scope.order[mode].direction = $scope.order[mode].direction === 'desc' ? 'asc' : 'desc';
		} else {
			$scope.order[mode].direction = 'desc';
		}

		$scope.order[mode].field = order;

		$scope.pageChanged();
	};

	$scope.link = function(){
		return window.location.href;
	};

	$scope.reset = function(){
		if(!window.confirm('Are you sure want to reset all config?')){
			return;
		}

		['groupCols', 'countCols', 'sumCols', 'selectCols', 'filterCols', 'order'].forEach(function(collectionName){
			let defaultFunction = 'default' + Utilities.ucFirst(collectionName);

			defaultFunction();
		});

		$scope.mode = 'list';
		$scope.currentPage = 1;
		$location.search().clear();

		$scope.pageChanged();
	};

	$scope.setMode = function(mode){
		$scope.mode = mode;
		$location.search('mode', mode);
		$scope.pageChanged();
	};

	let defaults = {
		selectCols: function(){
			$scope.selectCols = [];
		},
		groupCols: function(){
			$scope.groupCols = [];
		},
		countCols: function(){
			$scope.countCols = [];
		},
		sumCols: function(){
			$scope.sumCols = [];
		},
		filterGroups: function(){
			$scope.filterGroups = [
				{'boolean': 'and', filters: []}
			];
		},
		order: function(){
			$scope.order = {
				list: {
					field: 'campaign_starttime',
					direction: 'desc'
				},
				group: {
					field: 'delivery',
					direction: 'desc'
				}
			};
		}
	};

	try {
		$scope.currentPage = $location.search().page;
	} catch (e) {
		$scope.currentPage = 1;
	}

	['groupCols', 'countCols', 'sumCols', 'selectCols', 'filterGroups', 'order'].forEach(function(collectionName){
		try {
			$scope[collectionName] = angular.fromJson($location.search()[collectionName]) || $location.search()[collectionName];
		} catch (e) {
			defaults[collectionName]();
		}

		if(!$scope[collectionName]){
			defaults[collectionName]();
		}
	});

	$scope.$on('wk:colSelected', function(event, data){
		let col = data.col;

		let colIndex = $scope[data.type].findIndex(function(item){
			return item.table + item.name === col.table + col.name;
		});

		if(data.col.selected){
			$scope[data.type].push(col);
		} else {
			if(angular.isArray(colIndex)){
				colIndex.forEach(function(i){
					$scope[data.type].splice(i, 1);
				});
			} else if(colIndex > -1) {
				$scope[data.type].splice(colIndex, 1);
			}
		}
	});

	try {
		$scope.mode = $location.search().mode;
	} catch (e) {
		$scope.mode = 'list';
	}

	$scope.mode = $scope.mode || 'list';

	if($scope.mode === 'group' && $scope.cantGroup()){
		$scope.mode = 'list';
	}

	$scope.results = {
		list:  [],
		group: []
	};


	let config = jQuery("#config");
	$scope.fieldsConfig = JSON.parse(config.text());
	$scope.availableTables = Object.keys($scope.fieldsConfig.filter);

	$scope.addFilterGroup = function(){
		$scope.filterGroups.push({
			filters: [], boolean: 'and'
		})
	};

	$scope.removeFilterGroup = function($index){
		if(!window.confirm('Are you sure want to delete this group?')){
			return;
		}

		$scope.filterGroups.splice($index);
	};

	$timeout(function(){
		config.remove();
	}, 0);

}